module.exports = __webpack_public_path__ + "img/select_button_orange.4bfc1cea.png";